import config from '@/config/index';

console.log(config.host);

export default {
  method: 'post',
  // 基础url前缀
  baseURL: config.host,
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  transformResponse: [(data) => {
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }],
  // 参数
  data: {},
  // 设置超时时间
  timeout: 30000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: 'json',
  credentials: true,
};
